import {
  Boxes,
  Settings,
  Box,
  HomeIcon,
  Layers,
  ShieldCheck,
  VectorSquare,
  ListPlus,
  SquareM,
  BriefcaseBusiness,
  Map,
  Menu,
  Users,
  ShoppingCart,
  FileSpreadsheet,
  ListOrdered,
  Shield,
} from "lucide-react";

const menuData = [
  {
    label: "Dashboard",
    icon: HomeIcon,
    path: "/dashboard",
  },
  {
    label: "Menu",
    icon: Menu,
    path: "/menu",
  },
  { label: "Orders", icon: ShoppingCart, path: "/orders" },
  { label: "Customers", icon: Users, path: "/customers" },
  { label: "Categories", icon: Layers, path: "/categories" },
  {
    label: "Products",
    icon: Box,
    path: "/products",
  },

  {
    label: "Bulk Price List",
    icon: ListOrdered,
    path: "/bulk-price-list",
  },
  { label: "Price List", icon: ListPlus, path: "/price-list" },

  {
    label: "Master Tables",
    icon: Boxes,
    id: "uiBasic",
    subMenu: [
      { label: "Pack Size", icon: VectorSquare, path: "/pack-size" },
      { label: "Pack Bag", icon: BriefcaseBusiness, path: "/pack-bag" },
      { label: "Quality", icon: ShieldCheck, path: "/quality" },
      { label: "Source", icon: SquareM, path: "/traceability" },
      { label: "Grinds", icon: Box, path: "/grinds" },
      { label: "Price Type", icon: Box, path: "/price-type" },
      { label: "Order Status", icon: ShoppingCart, path: "/order-status" },
      { label: "Payment Status", icon: ShoppingCart, path: "/payment-status" },
      { label: "Country", icon: Map, path: "/country" },
    ],
  },
  {
    label: "Import / Export",
    icon: FileSpreadsheet,
    id: "importExport",
    subMenu: [
      { label: "Import Export Products", path: "/import-export-product" },
    ],
  },
  {
    label: "Settings",
    icon: Settings,
    id: "settings",
    subMenu: [
      { label: "Email Configuration", path: "/email-configuration" },
      { label: "Email Templates", path: "/email-template" },
      // { label: "Website Settings", path: "/website-setting" },
    ],
  },

   {
    label: "User Permissions",
    icon: Shield,
    id: "userPermissions",
    subMenu: [
      { label: "Page", path: "/page" },
      { label: "Users", path: "/users" },
    ],
  },
];

export default menuData;
